const AboutUs = () => {
  const pillars = [
    "Producto de máxima calidad",
    "Servicio cercano y profesional",
    "Experiencia gastronómica relajada",
  ];

  const values = [
    "Calidad del producto",
    "Servicio cercano",
    "Tradición gastronómica",
    "Producto local",
    "Respeto por el cliente",
    "Pasión por el vino",
  ];

  return (
    <section className="section-padding bg-[#F9F7F2]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1761062083136-dcfbd2a000f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxhbmRhbHVzaWFuJTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MzM0NzQzOXww&ixlib=rb-4.1.0&q=85"
                alt="Interior de Abacería Como en Casa"
                className="w-full h-[500px] object-cover"
              />
              {/* Decorative quote */}
              <div className="absolute -bottom-6 -right-6 bg-white p-6 shadow-lg max-w-xs hidden md:block">
                <p className="font-accent text-lg text-[#1A1A1A] italic">
                  "La buena comida merece disfrutarse sin prisa"
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="font-accent text-[#800020] text-lg mb-4">
              Sobre nosotros
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-6">
              Nuestra Filosofía
            </h2>

            <div className="gold-border-left mb-8">
              <p className="font-body text-[#1A1A1A]/80 leading-relaxed mb-4">
                <span className="font-heading text-lg">
                  Abacería & Fogón Como en Casa
                </span>{" "}
                nace con una idea muy clara: ofrecer lo mejor de la gastronomía
                española en un ambiente cercano y auténtico.
              </p>
            </div>

            {/* Pillars */}
            <p className="font-accent text-lg text-[#1A1A1A] mb-4">
              Nuestra propuesta se basa en tres pilares fundamentales:
            </p>
            <div className="space-y-3 mb-8">
              {pillars.map((pillar, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3"
                  data-testid={`pillar-${index}`}
                >
                  <span className="w-2 h-2 bg-[#C5A059]" />
                  <span className="font-body text-[#1A1A1A]">{pillar}</span>
                </div>
              ))}
            </div>

            <p className="font-body text-[#1A1A1A]/80 leading-relaxed mb-8">
              Creemos en el concepto{" "}
              <span className="font-accent italic">slow food</span>, donde la
              comida se prepara con respeto al producto y se disfruta sin prisa.
            </p>

            {/* Values */}
            <div className="bg-white p-6 border border-[#DCD7CC]">
              <h3 className="font-heading text-lg text-[#1A1A1A] mb-4">
                Nuestros Valores
              </h3>
              <div className="flex flex-wrap gap-2">
                {values.map((value, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-[#F9F7F2] border border-[#DCD7CC] font-body text-sm text-[#1A1A1A]/80"
                    data-testid={`value-${index}`}
                  >
                    {value}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
